import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-unavailable',
  templateUrl: './unavailable.component.html',
  styleUrls: ['./unavailable.component.sass'],
})
export class UnavailableComponent implements OnInit {
  constructor(private router: Router) {
    /** */
  }

/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
  ngOnInit(): void {
    /** */
  }
/* eslint-enable @angular-eslint/no-empty-lifecycle-method */

  /**
   * retry to connect
   */
  retry(): void {
    this.router.navigate(['/page/login']);
  }
}
